<template>
    <lk-form-item label='药品说明书:'>
        <lk-button @click="showDrugInstruction">查看</lk-button>
        <lk-modal
        v-model="showInstruction"
        title="药品说明书"
        :closable="false"
        @on-ok="close"
        @on-cancel="close"
        >
            <table>
            <tr>
                <td width="100px">成分:</td>
                <td>{{drugInstructionData.cf}}</td>
            </tr>
            <tr>
                <td>性状:</td>
                <td>{{drugInstructionData.xz}}</td>
            </tr>
            <tr>
                <td>适应症:</td>
                <td>{{drugInstructionData.syz}}</td>
            </tr>
            <tr>
                <td>用法用量:</td>
                <td>{{drugInstructionData.yfyl}}</td>
            </tr>
            <tr>
                <td>不良反应:</td>
                <td>{{drugInstructionData.blfy}}</td>
            </tr>
            <tr>
                <td>禁忌:</td>
                <td>{{drugInstructionData.jj}}</td>
            </tr>
            <tr>
                <td>注意事项:</td>
                <td>{{drugInstructionData.zysx}}</td>
            </tr>
            <tr>
                <td>妊娠及哺乳:</td>
                <td>{{drugInstructionData.rsjbr}}</td>
            </tr>
            <tr>
                <td>儿童用药:</td>
                <td>{{drugInstructionData.etyy}}</td>
            </tr>
            <tr>
                <td>老年用药:</td>
                <td>{{drugInstructionData.lnyy}}</td>
            </tr>
            <tr>
                <td>药物互相作用:</td>
                <td>{{drugInstructionData.ywxhzy}}</td>
            </tr>
            <tr>
                <td>药理作用:</td>
                <td>{{drugInstructionData.ylzy}}</td>
            </tr>
            <tr>
                <td>药物过量:</td>
                <td>{{drugInstructionData.ywgl}}</td>
            </tr>
            <tr>
                <td>贮藏:</td>
                <td>{{drugInstructionData.zc}}</td>
            </tr>
            <tr>
                <td>包装:</td>
                <td>{{drugInstructionData.bz}}</td>
            </tr>
            <tr>
                <td>执行标准:</td>
                <td>{{drugInstructionData.zxbz}}</td>
            </tr>
            <tr>
                <td>有效期:</td>
                <td>{{drugInstructionData.yxq}}</td>
            </tr>
            <tr>
                <td>生产企业:</td>
                <td>{{drugInstructionData.scqy}}</td>
            </tr>
            <tr>
                <td>附件勘误:</td>
                <td>{{drugInstructionData.fjkw}}</td>
            </tr>
            </table>
        </lk-modal>
    </lk-form-item>
</template>
<script>
import goodsStore from '../services/goods';
export default {
    name: 'drugInstruction',
    props: {
       approvalNumber: {
           type: String,
       },
       approvedDrugNames: {
           type: String,
       },
       manufacturer: {
           type: String,
       },
       drugSpec: {
           type: String
       },
       specifications: {
           type: String
       }
    },
    data() {
        return {
           showInstruction: false,
           drugInstructionData: {}
        }
    },
    methods: {
      close() {
          this.showInstruction = false;
      },
      showDrugInstruction() {
        const params = {
        pzwh : this.approvalNumber || '',
        // pzwh : 'H13021771',测试用
        ypmc : this.approvedDrugNames || '',
        cj : this.manufacturer || '',
        gg : this.specifications || '',
      }
      goodsStore.getDrugInstruction(params).then(res => {
        if(res.status === 200){
          this.showInstruction = true;
          this.drugInstructionData = res.data.data;
        } else {
          this.$Message.error(res.data.reason);
        }
      }).catch(err => {
        utils.handleError(err);
      })
      }
    },
    created(){
      
    },
    mounted(){
      
    }

}
</script>
